import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import {
  Account,
  BillingAddress,
  countries,
  Destroyable,
  notAllSpacesValidator,
  SaveForm,
  selectCurrentAccount,
  untilDestroy,
  updateAccountBillingAddresses,
} from '@tokeet/tv3-platform'
import { select, Store } from '@ngrx/store'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import * as lodash from 'lodash'
import { getCountryNameByCode } from '@tokeet/constants'

@Component({
  selector: 'app-billing-address-dialog',
  templateUrl: './billing-address-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./billing-address-dialog.component.scss'],
})
export class BillingAddressDialogComponent extends Destroyable implements OnInit {
  countryList = countries

  form = this.fb.group({
    key: [],
    name: ['', [notAllSpacesValidator]],
    address: ['', [Validators.required, notAllSpacesValidator]],
    city: ['', [Validators.required]],
    country: [],
    country_code: ['', [Validators.required]],
    postal_code: ['', [Validators.required]],
    state: ['', [Validators.required]],
  })
  account: Account

  constructor(
    private fb: FormBuilder,
    private store: Store<any>,
    public dialogRef: MatDialogRef<BillingAddressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { address: BillingAddress }
  ) {
    super()
  }

  ngOnInit() {
    if (this.data.address) {
      this.form.patchValue(this.data.address)
    }

    this.store.pipe(select(selectCurrentAccount), untilDestroy(this)).subscribe((data) => {
      this.account = data
    })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const formValues = form.getRawValue()
    formValues.country = getCountryNameByCode(formValues.country_code)
    let payload: BillingAddress[] = []
    if (formValues.key) {
      payload = lodash.map(this.account.invoiceBillingAddresses, (a) => {
        return a.key === formValues.key ? formValues : a
      })
    } else {
      payload = [...(this.account.invoiceBillingAddresses || []), formValues]
    }

    this.store.dispatch(updateAccountBillingAddresses({ addresses: payload }))
    this.close()
  }
}
